import api from './api';

/**
 * Upload a single image to Cloudinary
 * @param {File} file - Image file
 * @param {string} folder - Cloudinary folder path
 * @returns {Promise<Object>} Upload result with public_id and secure_url
 */
export const uploadImage = async (file, folder = 'knowindia/places') => {
  const formData = new FormData();
  formData.append('image', file);
  formData.append('folder', folder);

  const response = await api.post('/admin/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  return response.data;
};

/**
 * Upload multiple images to Cloudinary
 * @param {File[]} files - Array of image files
 * @param {string} folder - Cloudinary folder path
 * @returns {Promise<Object>} Upload result with array of images
 */
export const uploadMultipleImages = async (files, folder = 'knowindia/places') => {
  const formData = new FormData();
  files.forEach(file => {
    formData.append('images', file);
  });
  formData.append('folder', folder);

  const response = await api.post('/admin/upload/multiple', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  return response.data;
};

/**
 * Delete an image from Cloudinary by public_id
 * @param {string} publicId - Cloudinary public_id
 * @returns {Promise<Object>} Deletion result
 */
export const deleteImage = async (publicId) => {
  const encodedPublicId = encodeURIComponent(publicId);
  const response = await api.delete(`/admin/upload/${encodedPublicId}`);
  return response.data;
};

/**
 * Delete an image from Cloudinary by URL
 * @param {string} url - Cloudinary image URL
 * @returns {Promise<Object>} Deletion result
 */
export const deleteImageByUrl = async (url) => {
  const response = await api.post('/admin/upload/delete-by-url', { url });
  return response.data;
};

const uploadService = {
  uploadImage,
  uploadMultipleImages,
  deleteImage,
  deleteImageByUrl
};

export default uploadService;

